

















































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import { db, auth, busy, VIPProject, IVIPProject, VIPProjectRest, ICapabilities, toaster, VIPContact, VIPUser, VIPIp, VIPProjectIpRest, DBType } from "@/loader/public";
import EntityEdit from "@/component/EntityEdit";
import { VIPProjectEditComponentMixin } from '@/mixins/VIPProjectMixin';

@Component
export default class ProjectEdit extends Mixins(VIPProjectEditComponentMixin) {
	public get canEdit(): boolean {
		return (auth.user?.capabilities.edit_vip_project || false) && !this.item.isStatusCancelled;
	}

	public get projectIps(): number[] {
		return this.item?.ips.map(pip => pip.fk_ip) || [];
	};

	public set projectIps(ids: number[]) {
		ids.forEach(id => {
			if (!this.item.ips.find(pip => pip.fk_ip === id)) {
				db.projectIps.insert({
					fk_project: this.item.id,
					fk_ip: id,
				});
			}
		});
		this.item.ips.forEach(pip => {
			if (!ids.includes(pip.fk_ip)) {
				db.projectIps.remove(pip);
			}
		});
	}

	public get ips(): VIPIp[] {
		return db.ips.list.sort((a, b) => a.code.toString().localeCompare(b.code.toString()));
	}

	public get contacts(): VIPContact[] {
		return this.item.company?.contacts || [];
	}

	public get users(): VIPUser[] {
		return db.users.list.filter(u => u.isManager);
	}

	public save() {
		if (!this.canEdit || !this.item) {
			return;
		}
		if (!this.check()) {
			toaster.toast({ message: "Certaines informations ne sont pas valides.", variant: "warning", noAutoHide: false });
			return;
		}

		busy.start(`Sauvegarde du projet ${this.item.name} ...`);
		let ips = this.item.ips.map(pip => pip.fk_ip);
		let p = this.item.id < 0 ? VIPProjectRest.create(this.item) : VIPProjectRest.update(this.item);
		p.then(result => {
			if (result.success) {
				return VIPProjectIpRest.batch(result.item.id, ips);
			}
			return result;
		}).then(result => {
			if (result.success) {
				this.changed = false;
				this.unfocusAll();
				toaster.toast({ message: `Le projet ${this.item.name} a été sauvegardé`, variant: "success" });
				this.$emit("saved", this.item);
			}
		}).finally(() => {
			busy.stop();
		});
	}

	public mounted() {
		if (this.item && this.isNew) {
			this.redirection = { name: "Company", params: { id: this.item.fk_company } };
		} else {
			this.redirection = null;
		}
	}
}
